import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ 
    name: 'priceFormat',
    standalone: true
})
export class PriceCurrencyPipe implements PipeTransform {
	transform(price: (number|string), currency:string) {
        
        var p = Number(price);

        let currency_format = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency,
        });

        return currency_format.format(p);
    }
}

